import React from "react"
import { Alert } from "reactstrap"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { useQuery } from "@apollo/react-hooks"
import { Spinner } from "components/spinner"
import CategoryForm from "./CategoryForm"
import { GET_CATEGORY } from "../gql"

document.body.scrollTop = 0 // For Safari
document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

const CategoryDetailContainer = props => {
  const categoryId = props.match.params.id
  const { data, loading, error, refetch } = useQuery(GET_CATEGORY, {
    skip: !categoryId,
    variables: { id: categoryId },
    fetchPolicy: "cache-and-network"
  })

  useBread({
    to: props.match.url,
    name: props.match.params.id ? "維護類別" : "新增類別"
  })

  if (loading) {
    return <Spinner />
  }

  if (error) {
    return <Alert color="danger">錯誤訊息：{`${error}`}</Alert>
  }

  return <CategoryForm data={data?.category} refetch={refetch} />
}

export default withBreadcrumb(CategoryDetailContainer)
